if (!customElements.get("ingredients-list-controller")) {
  class IngredientsListController extends HTMLElement {
    connectedCallback() {
      this.filterButtons = Array.from(this.querySelectorAll("[data-ingredient-filter]"));
      this.ingredientItems = Array.from(this.querySelectorAll("[data-tags]"));
      this.ingredientsContainer = this.querySelector("#ingredients-list");
      this.ingredientsCta = document.querySelector("#ingredient-list-cta");
      this.ctaShowText = this.ingredientsCta?.querySelector("[data-cta-show]");
      this.ctaHideText = this.ingredientsCta?.querySelector("[data-cta-hide]");
      this.ctaIcon = this.ingredientsCta?.querySelector("[data-cta-icon]");

      if (this.ingredientsCta) {
        this.handleIngredientsLinkCta = this.handleIngredientsLinkCta.bind(this);
        this.ingredientsCta.addEventListener("click", this.handleIngredientsLinkCta);
      }

      this.filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          if (!button.classList.contains("ingredient-tag-selected")) {
            this.filterButtons.forEach((btn) => btn.classList.remove("ingredient-tag-selected"));
            button.classList.add("ingredient-tag-selected");
            this.filterIngredients();
          }
        });
      });
    }

    handleIngredientsLinkCta() {
      const isHidden = this.ingredientsContainer.classList.contains("hidden");
      this.ingredientsContainer.classList.toggle("hidden", !isHidden);
      this.updateCtaText(!isHidden);
    }

    updateCtaText(isHidden) {
      if (this.ctaShowText) {
        this.ctaShowText.classList.toggle("hidden", !isHidden);
      }
      if (this.ctaHideText) {
        this.ctaHideText.classList.toggle("hidden", isHidden);
      }
      if (this.ctaIcon) {
        this.ctaIcon.classList.toggle("rotate-180", !isHidden);
      }
    }

    getSelectedIngredientFilter() {
      return (
        this.filterButtons
          .find((button) => button.classList.contains("ingredient-tag-selected"))
          ?.getAttribute("data-ingredient-filter") || null
      );
    }

    filterIngredients() {
      const selectedFilter = this.getSelectedIngredientFilter();

      this.ingredientItems.forEach((item) => {
        if (selectedFilter === "all") {
          item.setAttribute("style", "");
          return;
        }

        const itemTags = item.getAttribute("data-tags").split(",");

        if (!selectedFilter || itemTags.includes(selectedFilter)) {
          item.setAttribute("style", "");
        } else {
          item.setAttribute("style", "display: none;");
        }
      });
    }
  }

  customElements.define("ingredients-list-controller", IngredientsListController);
}
